import Icon from "./IconBase.js";
const AIIcon = (props) => {
  return (
    <Icon width="24" height="24" viewBox="5 5 24 24" {...props}>
      <svg
        width="28"
        height="28"
        viewBox="5 5 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.8636 10L25.7182 12.5L23.2273 13.6364L25.7182 14.7818L26.8636 17.2727L28 14.7818L30.5 13.6364L28 12.5M17.7727 12.7273L15.5 17.7273L10.5 20L15.5 22.2727L17.7727 27.2727L20.0455 22.2727L25.0455 20L20.0455 17.7273M26.8636 22.7273L25.7182 25.2182L23.2273 26.3636L25.7182 27.5L26.8636 30L28 27.5L30.5 26.3636L28 25.2182"
          fill="url(#paint0_linear_924_9128)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_924_9128"
            x1="8.90931"
            y1="10.4544"
            x2="30.0457"
            y2="31.5908"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#AA27F8" />
            <stop offset="1" stopColor="#2D84F9" />
          </linearGradient>
        </defs>
      </svg>
    </Icon>
  );
};
export default AIIcon;
